/**
 * `/$org/apps/probe/interviews/$sessionId`: one saved interview — its
 * review, with the transcript one tab over.
 *
 * @module routes/$org.apps.probe.interviews.$sessionId
 */
import { createFileRoute } from "@tanstack/react-router";

import { ProbeInterviewPage } from "../components/apps/probe/ProbeInterviewPage";

function ProbeInterviewRouteView() {
  const { sessionId } = Route.useParams();
  // Keyed, so moving between interviews starts each one from its own state.
  return <ProbeInterviewPage key={sessionId} interviewId={sessionId} />;
}

export const Route = createFileRoute("/$org/apps/probe/interviews/$sessionId")({
  component: ProbeInterviewRouteView,
});
